<template>
    <div class="select-page-section" :class="{retract:retracted}">
        <div class="header-select-page-section">
            <div class="chevron">
                <i class="fa-solid fa-chevron-left" @click="toggleStateRetracted"></i>
            </div>
            <h4>Publications</h4>
        </div>

        <div class="container-select-page">
            <SelectPage :groups="groups" :allPages="allPages" :SelectPageProp="SelectPage" @updateSelectPage="updateSelectPage"></SelectPage>
        </div>
       
    </div>
</template>

<script>
    import store from './../../store/index.js';
    import SelectPage from './SelectPage.vue';
    export default {
        components: {
            SelectPage,
        },

        props: {
        },

        data() {
            return {
              
            }
        },
        methods: {
            updateSelectPage(pages) {
                const pagesSelected = this.allPages.filter(p => pages.includes(p.id))
                this.$store.commit('selectPage/updateSelectPagePageSelected', pagesSelected);
                localStorage.setItem('last_selected_pages',JSON.stringify(pagesSelected))
            },
            toggleStateRetracted() {
                this.$store.commit('selectPage/updateSelectPageListRetracted', !this.retracted);
            }
        },

        computed: {
            groups() {
                return this.$store.getters['selectPage/selectPageGroups'];
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },

            SelectPage() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(p => p.id);
            },
            retracted() {
                return this.$store.getters['selectPage/selectPageStateListRetracted'];
            }
           

        },
    }
</script>

